var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "SMSBox" },
    [
      _c("el-card", { staticClass: "mb5" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "20px" } },
          [
            _c(
              "el-form",
              [
                _c(
                  "el-row",
                  { staticClass: "SMSTime" },
                  [
                    _c(
                      "el-col",
                      { staticStyle: { width: "auto" }, attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.createTime"),
                            },
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                clearable: false,
                                type: "daterange",
                                "value-format": "yyyy-MM-dd",
                                "default-time": ["00:00:00", "23:59:59"],
                                "range-separator": _vm.$t(
                                  "collectionCenter.to"
                                ),
                                "start-placeholder": _vm.$t(
                                  "collectionCenter.StartTime"
                                ),
                                "end-placeholder": _vm.$t(
                                  "collectionCenter.EndTime"
                                ),
                              },
                              on: { change: _vm.dateChange },
                              model: {
                                value: _vm.timeValue,
                                callback: function ($$v) {
                                  _vm.timeValue = $$v
                                },
                                expression: "timeValue",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticStyle: { width: "auto" }, attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.CustomerN"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                },
                                on: {
                                  focus: _vm.getNewestCustomer,
                                  change: _vm.changeCustomer,
                                },
                                model: {
                                  value: _vm.queryForm.params.customerId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "customerId",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.customerId",
                                },
                              },
                              _vm._l(
                                _vm.customerIdList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.username,
                                      value: item.id,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticStyle: { width: "auto" }, attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.MerchantN"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  remote: "",
                                  "reserve-keyword": "",
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseInput"
                                  ),
                                  "remote-method": _vm.remoteMethod,
                                  loading: _vm.loading,
                                },
                                on: { change: _vm.changeValue },
                                model: {
                                  value: _vm.merchantCodeValue,
                                  callback: function ($$v) {
                                    _vm.merchantCodeValue = $$v
                                  },
                                  expression: "merchantCodeValue",
                                },
                              },
                              _vm._l(
                                _vm.merchantCodeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.name,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticStyle: { width: "auto" }, attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.SMSType"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.queryForm.params.messageType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "messageType",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.messageType",
                                },
                              },
                              _vm._l(_vm.SMSTypeList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.msg,
                                    value: item.messageType,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticStyle: { width: "auto" }, attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.SMSStatus"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.queryForm.params.sendFlng,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "sendFlng",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.sendFlng",
                                },
                              },
                              _vm._l(_vm.SMSStatusList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.msg,
                                    value: item.sendFlng,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticStyle: { width: "auto" }, attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "collectionCenter.PlatformWhichBelongs"
                              ),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                },
                                model: {
                                  value: _vm.queryForm.params.platform,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "platform",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.platform",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.other"),
                                    value: 0,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: { label: "shein", value: 1 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "kwai", value: 2 },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.expressDelivery"
                                    ),
                                    value: 3,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value: "btn:collection-center:report:SMS:find",
                            expression:
                              "'btn:collection-center:report:SMS:find'",
                            arg: "remove",
                          },
                        ],
                        attrs: {
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.searchClick },
                      },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.search")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value: "btn:collection-center:report:SMS:reset",
                            expression:
                              "'btn:collection-center:report:SMS:reset'",
                            arg: "remove",
                          },
                        ],
                        attrs: { icon: "el-icon-refresh", size: "mini" },
                        on: { click: _vm.resetClick },
                      },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value: "btn:collection-center:report:SMS:export",
                            expression:
                              "'btn:collection-center:report:SMS:export'",
                            arg: "remove",
                          },
                        ],
                        class:
                          _vm.exportPage.length <= 0 && _vm.isClick
                            ? "onlyClickOnce10"
                            : "",
                        attrs: { icon: "el-icon-upload2", size: "mini" },
                        on: { click: _vm.download },
                      },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.export")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value: "btn:collection-center:report:SMS:BatchPush",
                            expression:
                              "'btn:collection-center:report:SMS:BatchPush'",
                            arg: "remove",
                          },
                        ],
                        class:
                          _vm.batchPushList.length <= 0 && _vm.isClick1
                            ? "onlyClickOnce10"
                            : "",
                        attrs: { size: "mini" },
                        on: { click: _vm.batchPush },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("collectionCenter.BatchPush")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-divider"),
          ],
          1
        ),
      ]),
      _c("el-card", [
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                ref: "smsRef",
                attrs: { "max-height": 600, border: "", data: _vm.tableDate },
                on: {
                  select: _vm.batchSelect,
                  "select-all": _vm.batchSelectAll,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("collectionCenter.ind"),
                    type: "index",
                    width: "60",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                (_vm.queryForm.pageNumber - 1) *
                                  _vm.queryForm.pageSize +
                                  scope.$index +
                                  1
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "customerId",
                    label: _vm.$t("collectionCenter.clientID"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "customerName",
                    label: _vm.$t("collectionCenter.CustomerName"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "merchantCode",
                    label: _vm.$t("collectionCenter.MerchantNum"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "merchantName",
                    label: _vm.$t("collectionCenter.MerchantName"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "receiveUser",
                    label: _vm.$t("collectionCenter.recipientS"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "platform",
                    label: _vm.$t("collectionCenter.platform"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.platform == 0
                                    ? _vm.$t("collectionCenter.other")
                                    : scope.row.platform == 1
                                    ? "shein"
                                    : scope.row.platform == 2
                                    ? "kwai"
                                    : scope.row.platform == 3
                                    ? _vm.$t("collectionCenter.expressDelivery")
                                    : ""
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "senderPhone",
                    label: _vm.$t("collectionCenter.ReceivingCall"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: scope.row.senderPhone,
                                  expression: "scope.row.senderPhone",
                                },
                              ],
                              staticStyle: {
                                "padding-right": "10px",
                                "box-sizing": "border-box",
                              },
                            },
                            [
                              _vm.phoneShowIndex ==
                                (_vm.queryForm.pageNumber - 1) *
                                  _vm.queryForm.pageSize +
                                  scope.$index +
                                  1 && _vm.showPhone.isShow
                                ? _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.showPhone.val) + " "
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.senderPhone)),
                                  ]),
                              _c(
                                "span",
                                { staticClass: "isShowSenderPhone" },
                                [
                                  _c("sensitive-view-button", {
                                    attrs: {
                                      revealed:
                                        _vm.phoneShowIndex ===
                                          (_vm.queryForm.pageNumber - 1) *
                                            _vm.queryForm.pageSize +
                                            scope.$index +
                                            1 && _vm.showPhone.isShow,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.findSenderPhone(
                                          scope.row,
                                          (_vm.queryForm.pageNumber - 1) *
                                            _vm.queryForm.pageSize +
                                            scope.$index +
                                            1
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "messageType",
                    label: _vm.$t("collectionCenter.messageType"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.messageType == 0
                                    ? _vm.$t("collectionCenter.lanshou")
                                    : scope.row.messageType == 1
                                    ? _vm.$t("collectionCenter.delivery")
                                    : scope.row.messageType == 2
                                    ? _vm.$t("collectionCenter.signFor")
                                    : scope.row.messageType == 3
                                    ? _vm.$t("collectionCenter.cabinetPickup")
                                    : ""
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "messageSource",
                    label: _vm.$t("collectionCenter.SMSSource"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.messageSource == 0
                                    ? "app"
                                    : scope.row.messageSource == 1
                                    ? "pc"
                                    : scope.row.messageSource == 3
                                    ? _vm.$t("collectionCenter.smartCabinet")
                                    : scope.row.messageSource == 2
                                    ? _vm.$t("collectionCenter.other")
                                    : ""
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "messageContent",
                    label: _vm.$t("collectionCenter.messageContent"),
                    "show-overflow-tooltip": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "packageCount",
                    label: _vm.$t("collectionCenter.NumberPackages"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: _vm.$t("collectionCenter.CreationTime"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sendTime",
                    label: _vm.$t("collectionCenter.SendingTime"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sendError",
                    label: _vm.$t("collectionCenter.SendErrorMessage"),
                    "show-overflow-tooltip": false,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "pre",
                              {
                                staticStyle: {
                                  "max-height": "200px",
                                  overflow: "auto",
                                  width: "500px",
                                },
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [_vm._v(_vm._s(scope.row.sendError))]
                            ),
                            _c("div", { staticClass: "paramsStyle" }, [
                              _vm._v(_vm._s(scope.row.sendError)),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sendFlng",
                    label: _vm.$t("collectionCenter.messageStatus"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                scope.row.sendFlng == 0
                                  ? _vm.$t("collectionCenter.NotSent")
                                  : scope.row.sendFlng == 1
                                  ? _vm.$t("collectionCenter.InTransit")
                                  : scope.row.sendFlng == 2
                                  ? _vm.$t("collectionCenter.sent")
                                  : _vm.$t("collectionCenter.SendFailure")
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.editSum
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.operation"),
                        width: "150",
                        fixed: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.sendClick(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "collectionCenter.ModifyTotalParcelsReceived"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2939712168
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c("el-pagination", {
              staticStyle: { margin: "10px 0" },
              attrs: {
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.queryForm.pageNumber,
                "page-sizes": [10, 20, 50, 100, 500, 1000],
                "page-size": _vm.queryForm.pageSize,
                total: _vm.total,
                background: "",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageNumber", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageNumber", $event)
                },
                "update:pageSize": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageSize", $event)
                },
                "update:page-size": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageSize", $event)
                },
                "current-change": _vm.getSMSPage,
                "size-change": _vm.getPageSize,
              },
            }),
          ],
          1
        ),
      ]),
      _vm.dialogVisible
        ? _c(
            "div",
            [
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: _vm.$t("collectionCenter.tips"),
                    visible: _vm.dialogVisible,
                    width: "30%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("collectionCenter.packagesReceivedNumber")
                          )
                        ),
                      ]),
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: _vm.$t("collectionCenter.pleaseInput"),
                        },
                        model: {
                          value: _vm.packageNumber,
                          callback: function ($$v) {
                            _vm.packageNumber = _vm._n($$v)
                          },
                          expression: "packageNumber",
                        },
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isNumber,
                              expression: "isNumber",
                            },
                          ],
                          staticClass: "enterIntegerClass",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("collectionCenter.pleaseEnterInteger")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c("el-button", { on: { click: _vm.sendCancel } }, [
                        _vm._v(_vm._s(_vm.$t("collectionCenter.cancel"))),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.sendOK },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }